module.exports = __webpack_public_path__ + "img/calendar-plus-fill.b95f900d.svg";